import React from 'react'
import { Navbar, Nav, Container, Dropdown } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { Routes } from '../Layout/RouteConfig'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../redux/rootReducer'
import { useHistory } from 'react-router-dom'
import { userPostSignOut } from '../../redux/User/actions'

const Header: React.FC = () => {
  const {
    userReducer: { isAuth, user },
  } = useSelector((state: RootState) => state)

  const history = useHistory()
  const dispatch = useDispatch()

  const handleLogOut = () => {
    dispatch(userPostSignOut())
    history.push(`${Routes.loginPage}`)
  }

  return (
    <Navbar bg="light" expand="lg">
      <Container fluid>
        <LinkContainer to={Routes.homePage}>
          <Nav.Link className={'d-flex align-center'}>
            <img
              className={'mr-2'}
              src="/images/Mobilise-Logo.png"
              alt="logo"
              width={200}
              height={40}
            />
            <p className="mb-0 mt-2">Api Platform</p>
          </Nav.Link>
        </LinkContainer>
        <Nav className="ml-auto align-center">
          {!isAuth && (
            <LinkContainer to={Routes.loginPage}>
              <Nav.Link>Login</Nav.Link>
            </LinkContainer>
          )}
          {isAuth && (
            <LinkContainer to={Routes.projectsPage}>
              <Nav.Link>Projects</Nav.Link>
            </LinkContainer>
          )}
          {isAuth && user.role === 'admin' && (
            <Dropdown>
              <Dropdown.Toggle variant="">Mobilise Admin</Dropdown.Toggle>
              <Dropdown.Menu align="right">
                <Dropdown.Item as={LinkContainer} to={Routes.users}>
                  <Nav.Link>Users Management</Nav.Link>
                </Dropdown.Item>
                <Dropdown.Item as={LinkContainer} to={Routes.audits}>
                  <Nav.Link>Audit Logs</Nav.Link>
                </Dropdown.Item>
                <Dropdown.Item as={LinkContainer} to={Routes.editProfile}>
                  <Nav.Link>Edit Profile</Nav.Link>
                </Dropdown.Item>
                <Dropdown.Item as="button" onClick={handleLogOut}>
                  Sign out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
          {isAuth && user.role !== 'admin' && (
            <Dropdown>
              <Dropdown.Toggle variant="">Mobilise Client</Dropdown.Toggle>
              <Dropdown.Menu align="right">
                <Dropdown.Item as={LinkContainer} to={Routes.editProfileClient}>
                  <Nav.Link>Edit Profile</Nav.Link>
                </Dropdown.Item>
                <Dropdown.Item as="button" onClick={handleLogOut}>
                  Sign out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </Nav>
      </Container>
    </Navbar>
  )
}

export default Header
